import { render, staticRenderFns } from "./FormCardProfileOther.vue?vue&type=template&id=ad0c40fa"
import script from "./FormCardProfileOther.vue?vue&type=script&lang=js"
export * from "./FormCardProfileOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports